if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',
    class LocalizationForm extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;

        const button = this.querySelector(
          'button.localization-form__select'
        );
        if (!button) return;

        this.bound = true;

        button.addEventListener('click', () => {
          this.initialize();

          if (button.getAttribute('aria-expanded') === 'true') {
            this.hidePanel();
          } else {
            this.openSelector();
          }
        });
      }

      initialize() {
        if (this.elements) return;

        const template = this.querySelector(
          'template[data-country-panel]'
        );

        if (template) {
          template.replaceWith(template.content.cloneNode(true));
        }

        this.header = document.querySelector('.header-wrapper');
        this.drawer = document.querySelector('.menu-drawer');

        this.elements = {
          button: this.querySelector(
            'button.localization-form__select'
          ),
          input: this.querySelector(
            'input[name="locale_code"], input[name="country_code"]'
          ),
          panel: this.querySelector('.disclosure__list-wrapper'),
          search: this.querySelector('input[name="country_filter"]'),
          reset: this.querySelector('.country-filter__reset-button'),
          searchIcon: this.querySelector('.country-filter__search-icon'),
          close: this.querySelector('.country-selector__close-button'),
          liveRegion: this.querySelector(
            '[data-country-search-results], #sr-country-search-results'
          ),
        };

        this.items = Array.from(
          this.querySelectorAll('a[data-value]')
        );

        this.countryNames = this.items.map((item) =>
          this.normalizeString(
            item.querySelector('.country')?.textContent ||
            item.textContent
          )
        );

        this.addEventListener('click', (event) => {
          const item = event.target.closest('a[data-value]');

          if (item && this.contains(item)) {
            event.preventDefault();
            this.elements.input.value = item.dataset.value;
            this.querySelector('form')?.submit();
            return;
          }

          if (event.target.closest('.country-selector__overlay')) {
            this.hidePanel();
          }
        });

        this.addEventListener('focusout', (event) => {
          if (!this.contains(event.relatedTarget)) {
            this.hidePanel();
          }
        });

        this.addEventListener('keydown', (event) => {
          if (
            this.elements.button.getAttribute('aria-expanded') !== 'true'
          ) return;

          if (event.key === 'Escape') {
            event.preventDefault();
            event.stopPropagation();
            this.hidePanel();
            this.elements.button.focus();
            return;
          }

          if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') {
            return;
          }

          const visible = this.items.filter(
            (item) => !item.parentElement.classList.contains('hidden')
          );

          if (!visible.length) return;

          event.preventDefault();

          const index = visible.indexOf(document.activeElement);
          const next = event.key === 'ArrowDown'
            ? (index + 1) % visible.length
            : (index <= 0 ? visible.length - 1 : index - 1);

          visible[next].focus();
        });

        this.elements.close?.addEventListener('click', () => {
          this.hidePanel();
          this.elements.button.focus();
        });

        if (this.elements.search) {
          this.elements.search.addEventListener('input', () => {
            this.filterCountries();
          });

          this.elements.search.addEventListener('keydown', (event) => {
            if (event.key === 'Enter') event.preventDefault();
          });

          this.elements.search.addEventListener('focus', () => {
            this.elements.searchIcon?.classList.add(
              'country-filter__search-icon--hidden'
            );
          });

          this.elements.search.addEventListener('blur', () => {
            if (!this.elements.search.value) {
              this.elements.searchIcon?.classList.remove(
                'country-filter__search-icon--hidden'
              );
            }
          });
        }

        this.elements.reset?.addEventListener('mousedown', (event) => {
          event.preventDefault();
        });

        this.elements.reset?.addEventListener('click', (event) => {
          event.preventDefault();
          this.elements.search.value = '';
          this.filterCountries();
          this.elements.search.focus();
        });
      }

      openSelector() {
        if (!this.elements.panel) return;

        this.elements.panel.hidden = false;
        this.elements.button.setAttribute('aria-expanded', 'true');

        if (!document.body.classList.contains('overflow-hidden-tablet')) {
          document.body.classList.add('overflow-hidden-mobile');
        }

        this.drawer?.classList.add('country-selector-open');

        if (this.header && this.hasAttribute('data-prevent-hide')) {
          this.header.preventHide = true;
        }

        if (window.matchMedia('(min-width: 750px)').matches) {
          this.elements.search?.focus();
        }
      }

      hidePanel() {
        if (!this.elements) return;

        this.elements.button.setAttribute('aria-expanded', 'false');

        if (this.elements.panel) {
          this.elements.panel.hidden = true;
        }

        document.body.classList.remove('overflow-hidden-mobile');
        this.drawer?.classList.remove('country-selector-open');

        if (this.header && this.hasAttribute('data-prevent-hide')) {
          this.header.preventHide = false;
        }

        if (this.elements.search) {
          this.elements.search.value = '';
          this.filterCountries();
          this.elements.searchIcon?.classList.remove(
            'country-filter__search-icon--hidden'
          );
        }
      }

      normalizeString(value) {
        return value
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .toLowerCase()
          .trim();
      }

      filterCountries() {
        const search = this.elements.search;
        if (!search) return;

        const value = this.normalizeString(search.value);
        let count = 0;

        this.items.forEach((item, index) => {
          const matches = this.countryNames[index].includes(value);
          item.parentElement.classList.toggle('hidden', !matches);
          if (matches) count++;
        });

        this.elements.reset?.classList.toggle('hidden', !value);

        this.querySelector('.popular-countries')?.classList.toggle(
          'hidden', Boolean(value)
        );

        if (this.elements.liveRegion) {
          const message =
            window.accessibilityStrings?.countrySelectorSearchCount;

          this.elements.liveRegion.textContent = message
            ? message.replace('[count]', String(count))
            : String(count);
        }

        const list = this.querySelector('.country-selector__list');
        if (list) list.scrollTop = 0;
      }
    }
  );
}
